<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <modelo-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ModeloCrud from "./ModeloCrud";
    export default {
        name: "Modelo",
        components: {ModeloCrud}
    }
</script>

<style scoped>

</style>

